import "slick-carousel/slick/slick.scss";
import "slick-carousel/slick/slick-theme.scss";
import 'lightgallery/src/sass/lightgallery.scss';

import {
    jarallax,
    jarallaxVideo
} from 'jarallax';
import 'bootstrap';
import 'slick-carousel';

import basicNavigation from './header/header';
import inlineSVG from './utilities/convert-svg-to-html';
import 'lightgallery';
import 'lg-thumbnail';
import 'lg-video';
import {HomeTiles} from "./components/slider";
import {Carousel} from "./blocks/carousel";
import lyricInvisibilityPromoPage from "./pages/lyric-invisibility-promo-page";


import Instafeed from 'instafeed.js';
import Swiper, { Navigation } from 'swiper/swiper-bundle';

window.Instafeed = Instafeed;


function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";

}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function showPopup() {
    var popup = getCookie("showPopup");
    if (popup === "") {
        $('#popupModal').modal('show');
        setCookie('showPopup', true, 3);
    }
}

$(window).on('load resize', function () {
    var boxWidth = $('.services-wrapper .service-box').outerWidth();
    var boxWidthHolder = $('.ServiceHolder .container .service-box').outerWidth();
    var storyBoxWidthHolder = $('.CustomerStoriesPage .container .story-box').outerWidth();
    $('.service-box').css({
        'height': boxWidth + 'px',
        'visibility': 'visible'
    });
    $('.ServiceHolder .service-box').css({
        'height': boxWidthHolder + 'px',
        'visibility': 'visible'
    });
    $('.CustomerStoriesPage .story-box').css({
        'height': storyBoxWidthHolder + 'px',
        'visibility': 'visible'
    });
    if($(window).width() < 768) {
        var maxHeight = 0;
        $(".carousel.full-height .slick-slide").each(function(){
            if ($(this).find(".slider-text-section").height() > maxHeight) {
                maxHeight = $(this).find(".slider-text-section").outerHeight();
            }
        });
        $(".carousel.full-height .slick-slide").each(function(){
            $(this).find(".slider-text-section").css('height', (maxHeight + 30) + 'px');
        });
    } else {
        $(".slider-text-section").css('height', 'auto');
    }
});

$(document).ready(function(){
    $('.top-header .social-icons').css('visibility', 'visible');
    showPopup();
    HomeTiles();
    lyricInvisibilityPromoPage();
    $('body').removeClass('preload');
});


$(function () {
    Swiper.use([Navigation]);
    // eslint-disable-next-line no-unused-vars
    var swiper = new Swiper('.phonak-slider', { // eslint-disable-no-unused-vars
        slidesPerView: 1,
        autoplay: {
            delay: 2000
        },
        autoHeight: true,
        loop: true,
        speed: 1500,
        effect: 'fade'
        // pagination: {
        //     el: ".swiper-pagination",
        //     clickable: true
        // }
    });

    if($('.unitron-slider').length > 0){
        var unitronpromoslider = new Swiper('.unitron-slider', { // eslint-disable-no-unused-vars
            slidesPerView: 1,
            autoplay: {
                delay: 1500
            },
            loop: true,
            speed: 1500,
            effect: 'fade',
            on: {
                init: function () {
                    document.getElementById('unitronSlider').style.visibility = 'visible';
                },
            }
        });
    }


    basicNavigation();
    jarallaxVideo();
    Carousel();

    jarallax(document.querySelectorAll('.HomePage .parallax.intro'), {
        videoSrc: 'https://www.youtube.com/watch?v=QGAMTlI6XxY',
        videoStartTime: 35,
        videoEndTime: 120,
        speed: 0.5
    });

    inlineSVG('.navbar-logo, .footer-logo, .admin-logo');

    $('.carousel.full-height .slick').slick({
        autoplay: true,
        autoplaySpeed: 3000,
        fade: true,
        arrows: false,
        pauseOnHover:false
    });

    $('.lightgallery').lightGallery({
        selector: '.lightgallery-item',
        thumbnail: true
    });


    $('.elemental-sponsors .slick').slick({
        slidesToShow: 5,
        arrows: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    arrows: false,
                    slidesToShow: 5
                }
            },
            {
                breakpoint: 992,
                settings: {
                    arrows: false,
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    slidesToShow: 2
                }
            }
        ]
    });

    $('.sliderr').slick({
        slidesToShow: 1,
        arrows: false,
        fade: true,
        infinite: true,
        autoplay: true,
        draggable: false,
        autoplaySpeed: 3500
    });

    $('.hail-carousel').each(function(index, element){
        //Build carousel options (from the Hail carousel DataObject)
        const slickOptions = {
            lazyLoad: 'ondemand',
            dots: ($(element).data('showdots') === "Yes"),
            slidesToShow: $(element).data('lg-toshow'),
            slidesToScroll: $(element).data('lg-toscroll'),
            responsive: [
                {
                    breakpoint: $(element).data('md-break'),
                    settings: {
                        slidesToShow: $(element).data('md-toshow'),
                        slidesToScroll: $(element).data('md-toscroll')
                    }
                },
                {
                    breakpoint: $(element).data('sm-break'),
                    settings: {
                        slidesToShow: $(element).data('sm-toshow'),
                        slidesToScroll: $(element).data('sm-toscroll'),
                        arrows: false
                    }
                }
            ]
        };

        $(element).slick(slickOptions);
    });

});

const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
        // console.log(entry.isIntersecting)
        // console.log(entry.target.classList)
        if (entry.isIntersecting) {
            entry.target.classList.add('show');
        } else {
            entry.target.classList.remove('show');
        }
    })
})

const hiddenElements = document.querySelectorAll('.hidden');
hiddenElements.forEach((el) => observer.observe(el));
